import photo from '@/assets/images/hero.webp'

/**
 * The office photo filling its parent (which must be `relative`), under an
 * optional overlay. `className` places the photo, e.g. `object-[center_30%]`;
 * `overlay` is the Tailwind background class of the layer above it.
 * Decorative: keep it the parent's first child so the content paints over it.
 */
export default function Backdrop({ className = '', overlay = '' }) {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-ink">
      <img
        src={photo}
        alt=""
        className={`size-full object-cover select-none ${className}`}
      />
      {overlay && <div className={`absolute inset-0 ${overlay}`} />}
    </div>
  )
}
